import config from "@/shared/plugins/link/linkConfig";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

class LinkService {
  private readonly whitelistedDomains: string[];

  constructor () {
    this.whitelistedDomains = config.whitelistedDomains;
  }

  isExternal (url: string): boolean {
    try {
      const parsedUrl = new URL(url, window.location.origin);

      return parsedUrl.origin !== window.location.origin;
    } catch {
      return false;
    }
  }

  isWhitelisted (url: string): boolean {
    try {
      const parsedUrl = new URL(url, window.location.origin);

      return this.whitelistedDomains.some(
        domain =>
          parsedUrl.hostname === domain ||
          parsedUrl.hostname.endsWith(`.${domain}`)
      );
    } catch {
      return false;
    }
  }

  requiresWarning (url: string): boolean {
    const featureFlagStore = useFeatureFlagStore();
    return (
      featureFlagStore.flags.bend31868DisplayWarningForExternalLinks &&
      this.isExternal(url) &&
      !this.isWhitelisted(url)
    );
  }
}

export default new LinkService();